module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13.734 8.281\"><path id=\"パス_83\" data-name=\"パス 83\" d=\"M4215.588,1337.939l5.453,5.453,5.453-5.453\" transform=\"translate(-4214.174 -1336.525)\" fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-miterlimit=\"10\" stroke-width=\"2\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/arrow_down.svg
// module id = KFdZ
// module chunks = 1